module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dark",
    on: {
      "click": _vm.closeProductTc
    }
  }, [_c('section', {
    staticClass: "product-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('header', [_c('img', {
    attrs: {
      "src": require("static/img/search-gray.png"),
      "alt": "icon"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "请输入产品名称或美团产品编号"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "搜索"
    },
    on: {
      "click": function($event) {
        _vm.getProductList(1, true)
      }
    }
  })]), _vm._v(" "), _c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.productData.data), function(item, index) {
    return _c('tr', {
      key: item.dealId
    }, [_c('td', [_vm._v(_vm._s(item.dealId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dealName))]), _vm._v(" "), _c('td', [(item.mtReviewCount !== 0) ? _c('span', [_vm._v(_vm._s(item.mtScore) + "分 " + _vm._s(item.mtReviewCount) + "条评价")]) : _c('span', {
      staticClass: "span-gray"
    }, [_vm._v("暂无评价")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatOnlineStatus")(item.onlineStatus)))]), _vm._v(" "), _c('td', [(item.mtReviewCount !== 0 && _vm.did != item.dealId) ? _c('router-link', {
      attrs: {
        "to": {
          name: _vm.businessTypeName + 'reviewDetail',
          params: {
            type: _vm.businessTypeName,
            id: item.dealId,
            name: item.dealName
          }
        }
      }
    }, [_vm._v("查看")]) : _c('span', {
      staticClass: "span-gray"
    }, [_vm._v("查看")])], 1)])
  }))]), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.productData.totalCount / 10),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("产品编号")]), _vm._v(" "), _c('th', [_vm._v("产品名称")]), _vm._v(" "), _c('th', [_vm._v("美团评价")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("产品状态")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206b3860","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/product/Product.vue
// module id = 728
// module chunks = 0